import { render, staticRenderFns } from "./FacilityContact.vue?vue&type=template&id=65642e76&scoped=true&"
import script from "./FacilityContact.vue?vue&type=script&lang=js&"
export * from "./FacilityContact.vue?vue&type=script&lang=js&"
import style0 from "./FacilityContact.vue?vue&type=style&index=0&id=65642e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65642e76",
  null
  
)

export default component.exports